import React, { useState, useEffect } from 'react';
import api from '../services/api'; 
import '../components/Admin/Contato/Modal/Modal.css';
import ModalAddAssunto from '../components/Admin/Contato/Modal/ModalAddAssunto';
import ModalConfirmDelete from '../components/Admin/Contato/Modal/ModalConfirmDelete';
import ModalSuccess from '../components/Admin/Contato/Modal/ModalSuccess';
import ModalConfirm from '../components/Admin/Modal/ModalConfirm';
import ModalError from '../components/Admin/Contato/Modal/ModalError';
import FormActions from '../components/Admin/FormActions/FormActions';
import './AdminContato.css';

const AdminContato = () => {
  // Dados Institucionais (Valores de fallback)
  const [textoInformativo, setTextoInformativo] = useState('Entre em contato pelo telefone (35) 3822-6251 ou pelo e-mail comunicacao@7geracoes.org.br.');
  const [emailDestino, setEmailDestino] = useState('comunicacao@7geracoes.org.br');

  // Textos de placeholders configuráveis
  const [placeholderNome, setPlaceholderNome] = useState('Insira seu nome');
  const [placeholderTelefone, setPlaceholderTelefone] = useState('Insira seu telefone:');
  const [placeholderEmail, setPlaceholderEmail] = useState('Insira seu e-mail');
  const [placeholderAssunto, setPlaceholderAssunto] = useState('Selecione o assunto:');
  const [placeholderMensagem, setPlaceholderMensagem] = useState('Que mensagem você quer deixar para a gente?');

  // Opções de assuntos
  const [assuntos, setAssuntos] = useState([
    'Ouvidoria', 'Currículo', 'Sugestão', 'Doação', 'Cadastro para receber notícias'
  ]);

  // Controles de interface e modais
  const [isAssuntosOpen, setIsAssuntosOpen] = useState(true);
  const [isModalAddOpen, setIsModalAddOpen] = useState(false);
  const [novoAssunto, setNovoAssunto] = useState('');
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [assuntoToDelete, setAssuntoToDelete] = useState(null);
  const [isModalSuccessOpen, setIsModalSuccessOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [isModalErrorOpen, setIsModalErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [isModalCancelarOpen, setIsModalCancelarOpen] = useState(false);

  // INTEGRAÇÃO COM API - BUSCAR DADOS (GET /contact-page/admin)
  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        // Rota admin protegida por token (prefixo /contato, registrado em routes/index.js)
        const response = await api.get('/contato/admin');
        const dbData = response.data;

        if (dbData) {
          if (dbData.informativeText) setTextoInformativo(dbData.informativeText);
          if (dbData.sendButtonEmail) setEmailDestino(dbData.sendButtonEmail);
          
          if (dbData.nameField?.placeholder) setPlaceholderNome(dbData.nameField.placeholder);
          if (dbData.phoneField?.placeholder) setPlaceholderTelefone(dbData.phoneField.placeholder);
          if (dbData.emailField?.placeholder) setPlaceholderEmail(dbData.emailField.placeholder);
          if (dbData.subjectField?.placeholder) setPlaceholderAssunto(dbData.subjectField.placeholder);
          if (dbData.messageField?.placeholder) setPlaceholderMensagem(dbData.messageField.placeholder);

          if (dbData.subjectField?.subjects && dbData.subjectField.subjects.length > 0) {
            setAssuntos(dbData.subjectField.subjects.map(sub => sub.name));
          }
        }
      } catch (error) {
        console.error("Erro ao carregar dados do banco. Mantendo os valores fixos de fallback.", error);
      }
    };

    fetchAdminData();
  }, []);

  const handleConfirmAddAssunto = (e) => {
    e.preventDefault();
    const nomeAssunto = novoAssunto.trim();
    if (nomeAssunto === '') return;

    const jaExiste = assuntos.some(
      (assunto) => assunto.trim().toLowerCase() === nomeAssunto.toLowerCase()
    );

    if (jaExiste) {
      setIsModalAddOpen(false);
      setNovoAssunto('');
      setErrorMessage(`O assunto "${nomeAssunto}" já existe na lista.`);
      setIsModalErrorOpen(true);
      return;
    }

    setAssuntos([...assuntos, nomeAssunto]);
    setIsModalAddOpen(false);
    setNovoAssunto('');
    setSuccessMessage('ASSUNTO ADICIONADO COM SUCESSO!');
    setIsModalSuccessOpen(true);
    setIsAssuntosOpen(true);
  };

  const handleRequestDelete = (index) => {
    if (assuntos.length <= 1) {
      setErrorMessage('É necessário manter pelo menos um assunto na lista.');
      setIsModalErrorOpen(true);
      return;
    }
    setAssuntoToDelete(index);
    setIsModalDeleteOpen(true);
  };

  const handleConfirmDelete = () => {
    if (assuntoToDelete !== null) {
      setAssuntos(assuntos.filter((_, idx) => idx !== assuntoToDelete));
      setIsModalDeleteOpen(false);
      setAssuntoToDelete(null);
      setSuccessMessage('ASSUNTO EXCLUÍDO COM SUCESSO!');
      setIsModalSuccessOpen(true);
    }
  };

  const handleOpenModal = () => {
    setNovoAssunto('');
    setIsModalAddOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalAddOpen(false);
    setNovoAssunto('');
  };

  // INTEGRAÇÃO COM API - SALVAR ALTERAÇÕES (PUT /contact-page/admin)
  const handleSalvar = async (e) => {
    e.preventDefault();
    // Mesma regra usada no backend (ContactPageController.js), para evitar
    // que um e-mail aceito aqui seja rejeitado só na hora de salvar
    const emailRegex = /^\S+@\S+\.\S+$/;
    const trimmedEmailDestino = emailDestino.trim();
    if (!emailRegex.test(trimmedEmailDestino)) {
      setErrorMessage("Por favor, insira um e-mail válido no campo 'E-mail de Recebimento'.");
      setIsModalErrorOpen(true);
      return;
    }

    setIsSaving(true);
    try {
      // Ajustado estritamente para o formato que o ContactPageController.js espera receber
      const payloadData = {
        contactPage: {
          nameField: { placeholder: placeholderNome.trim() },
          phoneField: { placeholder: placeholderTelefone.trim() },
          emailField: { placeholder: placeholderEmail.trim() },
          subjectField: {
            placeholder: placeholderAssunto.trim(),
            subjects: assuntos.map((sub, idx) => ({
              name: sub.trim(),
              order: idx
            }))
          },
          messageField: { placeholder: placeholderMensagem.trim() },
          informativeText: textoInformativo.trim(),
          sendButtonEmail: trimmedEmailDestino
        }
      };

      // Chamada PUT na rota admin correta (prefixo /contato, registrado em routes/index.js)
      await api.put('/contato/admin', payloadData);

      setSuccessMessage('ALTERAÇÕES SALVAS COM SUCESSO!');
      setIsModalSuccessOpen(true);
      setEditing(false);
    } catch (error) {
      console.error("Erro ao salvar no banco:", error);
      const errorMsg = error.response?.data?.error || "Ocorreu um erro ao salvar as configurações. Tente novamente.";
      setErrorMessage(errorMsg);
      setIsModalErrorOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancelar = () => {
    setIsModalCancelarOpen(true);
  };

  const handleConfirmCancelar = () => {
    window.location.reload();
  };

  const handleEditar = () => {
    setEditing(true);
  };

  const TrashOutlineIcon = () => (
    <svg className="icon-blue" viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  );

  return (
    <>
      <main className="main-content">
        <div className="form-container">
          <div className="page-title">
            <h1>EDITAR SEÇÃO</h1>
            <h2>Contato</h2>
          </div>

          <form className="admin-form" onSubmit={handleSalvar}>

            <div className="form-row">
              <div className="form-group flex-1">
                <div className="label-wrapper"><label>E-mail de Recebimento (Botão Enviar)</label></div>
                <input type="email" value={emailDestino} onChange={(e) => setEmailDestino(e.target.value)} placeholder="exemplo@7geracoes.org.br" disabled={!editing} required />
              </div>
            </div>

            <div className="form-group">
              <div className="label-wrapper"><label>Texto Informativo Institucional</label></div>
              <div className="mensagem-row">
                <textarea value={textoInformativo} onChange={(e) => setTextoInformativo(e.target.value)} style={{ minHeight: '80px' }} disabled={!editing} required ></textarea>
              </div>
            </div>

            <hr style={{ border: 'none', borderTop: '1px solid var(--primary-blue)', opacity: 0.2, margin: '2rem 0' }} />

            <div className="form-row">
              <div className="form-group flex-1">
                <div className="label-wrapper"><label>Texto do Campo: Nome</label></div>
                <input type="text" placeholder="Insira seu nome" value={placeholderNome} onChange={(e) => setPlaceholderNome(e.target.value)} disabled={!editing} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group flex-1">
                <div className="label-wrapper"><label>Texto do Campo: E-mail</label></div>
                <input type="text" placeholder="Insira seu e-mail" value={placeholderEmail} onChange={(e) => setPlaceholderEmail(e.target.value)} disabled={!editing} />
              </div>
              <div className="form-group flex-1">
                <div className="label-wrapper"><label>Texto do Campo: Telefone</label></div>
                <input type="text" placeholder="Insira seu telefone" value={placeholderTelefone} onChange={(e) => setPlaceholderTelefone(e.target.value)} disabled={!editing} />
              </div>
            </div>

            <div className="form-group mt-large">
              <div className="label-wrapper"><label>Assuntos</label></div>
              <div className="assunto-row">
                <div className="assunto-box">
                  
                  <div 
                    className="assunto-header" 
                    onClick={() => setIsAssuntosOpen(!isAssuntosOpen)} 
                    style={{ cursor: 'pointer' }}
                  >
                    <span>{placeholderAssunto}</span>
                    <svg 
                      viewBox="0 0 24 24" 
                      width="20" height="20" 
                      fill="#2b4c9b"
                      style={{ 
                        transform: isAssuntosOpen ? 'rotate(180deg)' : 'rotate(0deg)', 
                        transition: 'transform 0.3s ease' 
                      }}
                    >
                      <path d="M7 10l5 5 5-5z"/>
                    </svg>
                  </div>
                  
                  {isAssuntosOpen && (
                    <>
                      <ul className="assunto-list">
                        {assuntos.map((assunto, idx) => (
                          <li key={idx}>
                            {assunto}
                            <button type="button" className="action-btn" onClick={() => handleRequestDelete(idx)} disabled={!editing}>
                              <TrashOutlineIcon />
                            </button>
                          </li>
                        ))}
                      </ul>
                      {editing && (
                        <div className="assunto-footer" onClick={handleOpenModal} style={{ cursor: 'pointer' }}>
                          <span>Adicionar novo assunto</span>
                          <svg viewBox="0 0 24 24" width="20" height="20" stroke="#2b4c9b" strokeWidth="3" fill="none">
                            <line x1="12" y1="5" x2="12" y2="19"></line>
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                          </svg>
                        </div>
                      )}
                    </>
                  )}
                  
                </div>
              </div>
            </div>

            <div className="form-group mt-large">
              <div className="label-wrapper"><label>Texto do Campo: Mensagem</label></div>
              <div className="mensagem-row">
                <textarea value={placeholderMensagem} onChange={(e) => setPlaceholderMensagem(e.target.value)} disabled={!editing}></textarea>
              </div>
            </div>

            <FormActions
              editing={editing}
              onEdit={handleEditar}
              onCancel={handleCancelar}
              saveType="submit"
              saving={isSaving}
            />
          </form>
        </div>
      </main>

      <ModalAddAssunto isOpen={isModalAddOpen} onClose={handleCloseModal} onConfirm={handleConfirmAddAssunto} novoAssunto={novoAssunto} setNovoAssunto={setNovoAssunto} />
      <ModalConfirmDelete isOpen={isModalDeleteOpen} onClose={() => { setIsModalDeleteOpen(false); setAssuntoToDelete(null); }} onConfirm={handleConfirmDelete} />
      <ModalSuccess isOpen={isModalSuccessOpen} onClose={() => setIsModalSuccessOpen(false)} message={successMessage} />
      <ModalError isOpen={isModalErrorOpen} onClose={() => setIsModalErrorOpen(false)} message={errorMessage} />
      <ModalConfirm isOpen={isModalCancelarOpen} onClose={() => setIsModalCancelarOpen(false)} onConfirm={handleConfirmCancelar} message="Deseja descartar as alterações não salvas?" />
    </>
  );
};

export default AdminContato;
